/* istanbul ignore next not useful for unit test as the matchMedia belongs to the browser */
export const isDarkTheme = () => window.matchMedia?.('(prefers-color-scheme: dark)').matches
